// extracted by mini-css-extract-plugin
module.exports = {"SearchNotificationContainer":"SearchNotification_SearchNotificationContainer__gF7Qx"};